import { render, staticRenderFns } from "./CaracteristicasBarredores.vue?vue&type=template&id=f6904c86&scoped=true&"
import script from "./CaracteristicasBarredores.vue?vue&type=script&lang=ts&"
export * from "./CaracteristicasBarredores.vue?vue&type=script&lang=ts&"
import style0 from "./CaracteristicasBarredores.vue?vue&type=style&index=0&id=f6904c86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6904c86",
  null
  
)

export default component.exports